import { and, eq, type InitialQueryBuilder, isNull } from "@tanstack/db";

import type { WsWorkflowItem } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { WorkflowItem } from "@/store/types";

export async function deleteWsDraft(draftId: string) {
  store.delete("workflowItem", [draftId]);
}

export async function bulkUpsertWorkflowItem(records: WsWorkflowItem[]) {
  if (records.length === 0) return;
  const data = records.map(
    (r): WorkflowItem => ({
      id: r.id,
      workspaceId: r.workspaceId,
      contentId: r.contentId,
      createdAt: r.createdAt ?? null,
      deletedAt: r.deletedAt ?? null,
      displayName: r.displayName ?? null,
    }),
  );
  store.upsert("workflowItem", data);
}

export const workflowItemsQuery = (workspaceId: string) => (q: InitialQueryBuilder) =>
  q
    .from({ workflowItem: store.collection("workflowItem") })
    .where(({ workflowItem }) => and(eq(workflowItem.workspaceId, workspaceId), isNull(workflowItem.deletedAt)))
    .orderBy(({ workflowItem }) => workflowItem.createdAt, { direction: "desc", nulls: "first" });
